import {useLocale} from "../context/LocaleContext";
import React, { useState } from "react";
import { api } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { toast } from "sonner";
import { Mail, User as UserIcon, Loader2, Send } from "lucide-react";
import { formErrorMessage } from "../formFeedback";

export default function ContactPage() {
 const {t: translate, locale: currentLocale}=useLocale();

  const [data, setData] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setFeedback(null);
    setBusy(true);
    try {
      await api.post("/contact", data);
      setFeedback({ error: false, text: "Mesajınız kaydedildi." });
      toast.success(translate("Mesajınız kaydedildi"));
      setData({ name: "", email: "", message: "" });
    } catch (err) {
      const text = formErrorMessage(err, "Mesaj gönderilemedi. Bilgileriniz korunuyor; tekrar deneyebilirsiniz.");
      setFeedback({ error: true, text });
      toast.error(translate(text));
    } finally {
      setBusy(false);
    }
  };

  const fieldStyle = { background: "rgba(255,255,255,0.04)", borderColor: "var(--sy-border)", color: "var(--sy-text)" };

  return (
    <div className="px-6 py-10 lg:px-10">
      <div className="mx-auto max-w-2xl sy-fade-in">
        <div className="mb-7">
          <h1 className="font-display text-3xl font-semibold sy-gold-text">{translate("İletişim")}</h1>
          <p className="text-sm" style={{ color: "var(--sy-text-dim)" }}>{" "}{translate("Soru, görüş ve taleplerinizi bize iletebilirsiniz.")}{" "}</p>
        </div>

        <form onSubmit={submit} aria-busy={busy} className="rounded-2xl border p-7 space-y-4" style={{ background: "var(--sy-panel)", borderColor: "var(--sy-border)" }}>
          <label htmlFor="contact-name" className="block text-sm">{translate("Ad Soyad")}</label>
          <div className="relative">
            <UserIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "var(--sy-text-dim)" }} />
            <Input id="contact-name" name="name" autoComplete="name" required minLength={2} maxLength={80} placeholder={translate("Ad Soyad")} className="pl-9" style={fieldStyle} value={data.name} onChange={(e) => setData({ ...data, name: e.target.value })} />
          </div>
          <div className="relative">
            <label htmlFor="contact-email" className="sr-only">{translate("E-posta")}</label>
            <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "var(--sy-text-dim)" }} />
            <Input id="contact-email" name="email" autoComplete="email" type="email" required placeholder={translate("E-posta")} className="pl-9" style={fieldStyle} value={data.email} onChange={(e) => setData({ ...data, email: e.target.value })} />
          </div>
          <label htmlFor="contact-message" className="block text-sm">{translate("Mesajınız")}</label>
          <Textarea id="contact-message" name="message" required minLength={5} maxLength={2000} rows={5} placeholder={translate("Mesajınız…")} style={fieldStyle} value={data.message} onChange={(e) => setData({ ...data, message: e.target.value })} />
          {feedback && <p role={feedback.error ? "alert" : "status"}>{translate(feedback.text)}</p>}
          <Button type="submit" disabled={busy} className="w-full gap-2 font-semibold" style={{ background: "linear-gradient(180deg,#e8d5a8 0%,#d6b876 55%,#b8954f 100%)", color: "#1a150b" }}>
            {busy && <Loader2 size={16} className="animate-spin" />} <Send size={16} />{" "}{translate("Gönder")}{" "}</Button>
        </form>
      </div>
    </div>
  );
}
